import { ReactNativeMessenger } from './utils/ReactNativeMessenger';

export const rnMessenger = new ReactNativeMessenger();
window.rnMessenger = rnMessenger;
rnMessenger.callbackName = 'window.rnMessenger.handleMessage';
